/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum edsn_Marktrol {
    LVLEVERANCIER = 'LVLeverancier',
    MVMEETVERANTWOORDELIJKE = 'MVMeetverantwoordelijke',
    PVPROGRAMMAVERANTWOORDELIJKE = 'PVProgrammaverantwoordelijke',
    ODAOVERIGE_DIENSTENAANBIEDER = 'ODAOverigeDienstenaanbieder',
    RNBREGIONALE_NETBEHEERDER = 'RNBRegionaleNetbeheerder',
    GDSEIGENAAR_GESLOTEN_DISTRIBUTIE_SYSTEEM = 'GDSeigenaarGeslotenDistributieSysteem',
    CSPCONGESTIE_SERVICE_PROVIDER = 'CSPCongestieServiceProvider',
    LNBLANDELIJK_NETBEHEERDER = 'LNBLandelijkNetbeheerder',
    BSPBALANCING_SERVICE_PROVIDER = 'BSPBalancingServiceProvider',
}
